const rutasSprites = [
  //Arbustos
  {
    name: "textura_arbusto_tipo1",
    type: "texture",
    path: "mapa/sprites/arbusto-tipo1.webp",
  },
  {
    name: "textura_arbusto_tipo1_alpha",
    type: "texture",
    path: "mapa/sprites/arbusto-tipo1-alpha.webp",
  },
  {
    name: "textura_arbusto_tipo2",
    type: "texture",
    path: "mapa/sprites/arbusto-tipo2.webp",
  },
  {
    name: "textura_arbusto_tipo2_alpha",
    type: "texture",
    path: "mapa/sprites/arbusto-tipo2-alpha.webp",
  },
  {
    name: "textura_arbusto_tipo3",
    type: "texture",
    path: "mapa/sprites/arbusto-tipo2.webp",
  },
  {
    name: "textura_arbusto_tipo3_alpha",
    type: "texture",
    path: "mapa/sprites/arbusto-tipo3-alpha.webp",
  },
  //Arbol
  {
    name: "textura_arbol_tipo1",
    type: "texture",
    path: "mapa/sprites/arbol-tipo1.webp",
  },
  {
    name: "textura_arbol_tipo1_alpha",
    type: "texture",
    path: "mapa/sprites/arbol-tipo1-alpha.webp",
  },
  {
    name: "textura_arbol_tipo2",
    type: "texture",
    path: "mapa/sprites/arbol-tipo2.webp",
  },
  {
    name: "textura_arbol_tipo2_alpha",
    type: "texture",
    path: "mapa/sprites/arbol-tipo2-alpha.webp",
  },
  {
    name: "textura_arbol_tipo3",
    type: "texture",
    path: "mapa/sprites/arbol-tipo3.webp",
  },
  {
    name: "textura_arbol_tipo3_alpha",
    type: "texture",
    path: "mapa/sprites/arbol-tipo3-alpha.webp",
  },
  {
    name: "textura_arbol_tipo4",
    type: "texture",
    path: "mapa/sprites/arbol-tipo4.webp",
  },
  {
    name: "textura_arbol_tipo4_alpha",
    type: "texture",
    path: "mapa/sprites/arbol-tipo4-alpha.webp",
  },
  //Arboles relleno
  {
    name: "textura_arboles_tipo1",
    type: "texture",
    path: "mapa/sprites/arboles-tipo1.webp",
  },
  {
    name: "textura_arboles_tipo1_alpha",
    type: "texture",
    path: "mapa/sprites/arboles-tipo1-alpha.webp",
  },
  {
    name: "textura_arboles_tipo2",
    type: "texture",
    path: "mapa/sprites/arboles-tipo2.webp",
  },
  {
    name: "textura_arboles_tipo2_alpha",
    type: "texture",
    path: "mapa/sprites/arboles-tipo2-alpha.webp",
  },
  {
    name: "textura_arboles_tipo3",
    type: "texture",
    path: "mapa/sprites/arboles-tipo3.webp",
  },
  {
    name: "textura_arboles_tipo3_alpha",
    type: "texture",
    path: "mapa/sprites/arboles-tipo3-alpha.webp",
  },
  //Personas
  
  {
    name: "textura_personas_tipo1_alpha",
    type: "texture",
    path: "mapa/sprites/personas-tipo1-alpha.webp",
  },
  {
    name: "textura_personas_tipo2_alpha",
    type: "texture",
    path: "mapa/sprites/personas-tipo2-alpha.webp",
  },
  {
    name: "textura_personas_tipo3_alpha",
    type: "texture",
    path: "mapa/sprites/personas-tipo3-alpha.webp",
  },
  {
    name: "textura_personas_tipo4_alpha",
    type: "texture",
    path: "mapa/sprites/personas-tipo4-alpha.webp",
  },
  {
    name: "textura_personas_tipo5_alpha",
    type: "texture",
    path: "mapa/sprites/personas-tipo5-alpha.webp",
  },  
  
];

export default rutasSprites;
